import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'
import RichText from '../RichText'
import Picture from '../Picture'

export const Container = styled.article``
export const _Link = styled(Link)`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  gap: ${pxToRem(16)};
  color: ${({ theme }) => theme.colors.black};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(24)};
  }
`
export const _Picture = styled(Picture)`
  flex: 0 0 auto;
  width: min(calc(100% / 3), ${pxToRem(216)});
`
export const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${pxToRem(24)};
`
export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.m375_h4}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h4}
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
  }
`
